<template>
    <div class="grow">
        <i :class="iconClass"></i>
        {{ text }}
    </div>
</template>

<script>
export default {
    name: 'ProComponent',
    props: {
        text: String,
        iconClass: String,
    }
}
</script>

<style lang="scss" scoped>
.grow { 
  transition: all .2s ease-in-out; 
}

.grow:hover { 
  transform: scale(1.1); 
}
</style>